import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, of } from 'rxjs';
import { isSupportedLanguage } from 'app/services/language/languages';
import { LegalPage, LegalPageContent, LegalPageService } from './legal-page.service';

export const legalPageResolver: ResolveFn<LegalPageContent | null> = route => {
  const page = route.data['page'] as LegalPage;
  const language = route.parent?.paramMap.get('lang');
  if (!isSupportedLanguage(language)) return of(null);
  return inject(LegalPageService).load(page, language).pipe(catchError(() => of(null)));
};
